export const WEBSITE = {
   DOMAIN: 'www.oncallhealthgroup.com'
}